import { url_base } from '../config/url';
import axios from 'axios';

export async function getApartmentsByBuilding(buildingId) {
  const token = localStorage.getItem('authToken');
  const result = await axios({
    method: 'get',
    url: `${url_base}/api/bluebuilding/buildings/${buildingId}/apartments`,
    headers: {
      Authorization: `JWT ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return result?.data;
}

export async function getBuildingsList() {
  const token = localStorage.getItem('authToken');
  const result = await axios({
    method: 'get',
    url: `${url_base}/api/bluebuilding/buildings`,
    headers: {
      Authorization: `JWT ${token}`,
      'Content-Type': 'application/json',
    },
  });

  return result?.data;
}

export async function deleteApartment(buildingId, apartmentId) {
  const token = localStorage.getItem('authToken');

  const result = await axios({
    method: 'delete',
    url: `${url_base}/api/bluebuilding/buildings/${buildingId}/apartments/${apartmentId}/`,

    headers: {
      Authorization: `JWT ${token}`,
      'Content-Type': 'application/json',
    },
  });

  return result?.data;
}

export async function getApartmentUsersByName(filterValue) {
  const buildingId = localStorage.getItem('buildingId');
  const result = await axios({
    method: 'get',
    url: `${url_base}/api/buildings/${buildingId}/apartments/${filterValue}`,
    headers: {
      Authorization: `JWT ${localStorage.getItem('authToken')}`,
      'Content-Type': 'application/json',
    },
  });

  return result?.data?.apartmentUsers || [];
}

export async function createCall(apartmentUserId, type) {
  const result = await axios({
    method: 'post',
    url: `${url_base}/api/call`,
    headers: {
      Authorization: `JWT ${localStorage.getItem('authToken')}`,
      'Content-Type': 'application/json',
    },
    data: {
      apartmentUserId,
      type,
    },
  });

  return result?.data;
}

export function updateCall(callId, data) {
  return axios({
    method: 'put',
    url: url_base + '/api/call/' + callId,
    headers: {
      Authorization: 'JWT ' + localStorage.getItem('authToken'),
      'Content-Type': 'application/json',
    },
    data: data,
  });
}

export async function getCall(callId) {
  try {
    const {
      data: { call },
    } = await axios({
      method: 'get',
      url: `${url_base}/api/call/${callId}`,
      headers: {
        Authorization: `JWT ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json',
      },
    });
    return call;
  } catch (error) {
    console.error('getCall --> Error', error);
    return null;
  }
}

export function getApartmentVisitors(apartmentId) {
  return axios({
    method: 'get',
    url: `${url_base}/api/apartments/${apartmentId}/visitors`,
    headers: {
      Authorization: `JWT ${localStorage.getItem('authToken')}`,
      'Content-Type': 'application/json',
    },
  });
}

export function createApartmentVisitor(apartmentId, data) {
  return axios({
    method: 'post',
    url: `${url_base}/api/apartments/${apartmentId}/visitors`,
    headers: {
      Authorization: `JWT ${localStorage.getItem('authToken')}`,
      'Content-Type': 'multipart/form-data',
    },
    data: data,
  });
}
